export enum ResetPasswordControlName {
  Login = 'login'
}
